export const MACHINE_TYPES = [
  { id: 0, en: 'TUNNEL', jp: 'トンネル' },
  { id: 1, en: 'BATCH', jp: 'バッチ' },
] as const

export const VOLUME_OPTIONS = [
  { label: '100%', value: 100 },
  { label: '75%', value: 75 },
  { label: '50%', value: 50 },
] as const
